import { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

export default function AdultToggle({ site, onChange }) {
  const [adult, setAdult] = useState(!!site?.adult);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    const next = !adult;
    setBusy(true);
    try {
      await api.post("/site/adult", { adult: next });
      setAdult(next);
      toast.success(next
        ? "Marked 18+ — you'll only ever match with other 18+ sites."
        : "18+ removed — your site matches the general pool again.");
      onChange && (await onChange());
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border border-white/10 bg-zinc-900/60 p-5" data-testid="adult-toggle-card">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 min-w-0">
          <div className="h-9 w-9 shrink-0 rounded-lg border border-rose-500/20 bg-rose-500/10 text-rose-400 flex items-center justify-center">
            <ShieldAlert size={16} />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-medium text-foreground">Adult / 18+ content</div>
            <p className="text-[12px] text-muted-foreground mt-0.5 leading-relaxed">
              Turn this on if your site publishes adult (18+) content. 18+ sites are kept in a separate
              pool and only ever match with other 18+ sites.
            </p>
          </div>
        </div>
        <button
          role="switch"
          aria-checked={adult}
          onClick={toggle}
          disabled={busy}
          data-testid="adult-toggle-switch"
          className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${adult ? "bg-rose-500" : "bg-zinc-700"}`}
        >
          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${adult ? "translate-x-6" : "translate-x-1"}`} />
        </button>
      </div>
    </div>
  );
}
